import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Footer_ScreenContext } from "../footer/footer-context";

declare let window: any;

export interface IReportsSalesCustomer_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IReportsSalesCustomer_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  B2BGetRolesById: any[];
  B2BGetRolesById_dummy: any[];
  KuikaB2B_OrderSalesCustomerHeaderMobile: any[];
  KuikaB2B_OrderSalesCustomerHeaderMobile_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  isComp186380Visible: "visible" | "hidden";
}

export class ReportsSalesCustomer_ScreenBase extends React.PureComponent<
  IReportsSalesCustomer_ScreenProps,
  any
> {
  static contextType = Footer_ScreenContext;
  declare context: React.ContextType<typeof Footer_ScreenContext>;
  reportssalescustomer_373528_value_kuikaSelectBoxRef: React.RefObject<any>;
  reportssalescustomer_330953_value_kuikaDateRef: React.RefObject<any>;
  reportssalescustomer_179452_value_kuikaDateRef: React.RefObject<any>;
  reportssalescustomer_624937_value_kuikaTableRef: React.RefObject<any>;
  reportssalescustomer_894803_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "782add75-a2c8-e698-bccf-af29bb1e9b35",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [
        {
          Id: 654370,
          PropertyName: "value",
          Value: "Sipariş Raporu",
          TagName: "Label5_value",
        },
        {
          Id: 555464,
          PropertyName: "value",
          Value: "Tarih Filtresi",
          TagName: "Label6_value",
        },
        {
          Id: 373528,
          PropertyName: "placeholder",
          Value: "Tarih Aralığı",
          TagName: "SelectBox1_placeholder",
        },
        {
          Id: 518571,
          PropertyName: "label",
          Value: "Temizle",
          TagName: "Button2_label",
        },
        {
          Id: 595833,
          PropertyName: "label",
          Value: "Uygula",
          TagName: "Button1_label",
        },
        {
          Id: 991795,
          PropertyName: "value",
          Value: "Başlangıç Zamanı",
          TagName: "Label7_value",
        },
        {
          Id: 330953,
          PropertyName: "placeholder",
          Value: "Başlangıç Tarihi...",
          TagName: "Date1_placeholder",
        },
        {
          Id: 511968,
          PropertyName: "value",
          Value: "Bitiş Zamanı",
          TagName: "Label8_value",
        },
        {
          Id: 179452,
          PropertyName: "placeholder",
          Value: "Bitiş Tarihi...",
          TagName: "Date2_placeholder",
        },
        {
          Id: 107900,
          PropertyName: "value",
          Value: "Sipariş Tarihi",
          TagName: "Label9_value",
        },
        {
          Id: 931071,
          PropertyName: "value",
          Value: "Sipariş Ref. Num",
          TagName: "Label11_value",
        },
        {
          Id: 974894,
          PropertyName: "value",
          Value: "Müşteri Adı",
          TagName: "Label13_value",
        },
        {
          Id: 965351,
          PropertyName: "value",
          Value: "Adet",
          TagName: "Label17_value",
        },
        {
          Id: 167599,
          PropertyName: "value",
          Value: "Metrekare",
          TagName: "Label15_value",
        },
      ],
    },
    {
      Id: "c2176777-61f9-4e18-a818-fb50309cde20",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 654370,
          PropertyName: "value",
          Value: "Order Report",
          TagName: "Label5_value",
        },
        {
          Id: 555464,
          PropertyName: "value",
          Value: " Date Filter",
          TagName: "Label6_value",
        },
        {
          Id: 373528,
          PropertyName: "placeholder",
          Value: "Date Range",
          TagName: "SelectBox1_placeholder",
        },
        {
          Id: 518571,
          PropertyName: "label",
          Value: "Clear",
          TagName: "Button2_label",
        },
        {
          Id: 595833,
          PropertyName: "label",
          Value: "Apply",
          TagName: "Button1_label",
        },
        {
          Id: 991795,
          PropertyName: "value",
          Value: "Start Time",
          TagName: "Label7_value",
        },
        {
          Id: 330953,
          PropertyName: "placeholder",
          Value: "Start Date...",
          TagName: "Date1_placeholder",
        },
        {
          Id: 511968,
          PropertyName: "value",
          Value: "End Time",
          TagName: "Label8_value",
        },
        {
          Id: 179452,
          PropertyName: "placeholder",
          Value: "End Date...",
          TagName: "Date2_placeholder",
        },
        {
          Id: 107900,
          PropertyName: "value",
          Value: "Order Date",
          TagName: "Label9_value",
        },
        {
          Id: 931071,
          PropertyName: "value",
          Value: "Order Reference Number",
          TagName: "Label11_value",
        },
        {
          Id: 974894,
          PropertyName: "value",
          Value: "Customer Name",
          TagName: "Label13_value",
        },
        {
          Id: 965351,
          PropertyName: "value",
          Value: "Quantity",
          TagName: "Label17_value",
        },
        {
          Id: 167599,
          PropertyName: "value",
          Value: "Square meters",
          TagName: "Label15_value",
        },
      ],
    },
    {
      Id: "9cad9fb6-641d-4a89-9e7b-43ab2ef099cd",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 654370, PropertyName: "value", Value: "Sipariş Raporu" },
        { Id: 555464, PropertyName: "value", Value: "Tarih Filtresi" },
        { Id: 373528, PropertyName: "placeholder", Value: "Tarih Aralığı" },
        { Id: 991795, PropertyName: "value", Value: "Başlangıç Zamanı" },
        {
          Id: 330953,
          PropertyName: "placeholder",
          Value: "Başlangıç Tarihi...",
        },
        { Id: 511968, PropertyName: "value", Value: "Bitiş Zamanı" },
        { Id: 179452, PropertyName: "placeholder", Value: "Bitiş Tarihi..." },
        { Id: 518571, PropertyName: "label", Value: "Temizle" },
        { Id: 595833, PropertyName: "label", Value: "Uygula" },
        { Id: 249813, PropertyName: "title", Value: "Title" },
        { Id: 107900, PropertyName: "value", Value: "Sipariş Tarihi" },
        { Id: 298883, PropertyName: "value", Value: "[datafield:orderdate]" },
        { Id: 931071, PropertyName: "value", Value: "Sipariş Ref. Num" },
        {
          Id: 495593,
          PropertyName: "value",
          Value: "[datafield:ordernumberws]",
        },
        { Id: 974894, PropertyName: "value", Value: "Müşteri Adı" },
        {
          Id: 416078,
          PropertyName: "value",
          Value: "[datafield:customerdescription]",
        },
        { Id: 965351, PropertyName: "value", Value: "Adet" },
        { Id: 328579, PropertyName: "value", Value: "[datafield:qty1]" },
        { Id: 167599, PropertyName: "value", Value: "Metrekare" },
        { Id: 231449, PropertyName: "value", Value: "[datafield:qty2]" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.reportssalescustomer_373528_value_kuikaSelectBoxRef =
      React.createRef();
    this.reportssalescustomer_330953_value_kuikaDateRef = React.createRef();
    this.reportssalescustomer_179452_value_kuikaDateRef = React.createRef();
    this.reportssalescustomer_624937_value_kuikaTableRef = React.createRef();
    this.reportssalescustomer_894803_value_kuikaPaginationRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      B2BGetRolesById: [],
      KuikaB2B_OrderSalesCustomerHeaderMobile: [],
      SetValueOf: "",
      NAVIGATE: "",
      dataSource_373528: [
        { key: "10", text: "İki Tarih Arası Filtreleme" },
        { key: "1", text: "Bugün" },
        { key: "2", text: "Son 7 Gün" },
        { key: "3", text: "Son 1 Ay" },
        { key: "4", text: "Son 3 Ay" },
        { key: "5", text: "Son 6 Ay" },
        { key: "6", text: "Son 1 Yıl" },
        { key: "7", text: "Tüm Tarihler" },
      ],
      isComp186380Visible: "hidden",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "reportssalescustomer",
        "footer_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.ReportsSalesCustomerPageInit();
    } else if (
      !this.context?.callCallbackFunction ||
      this.context?.isMasterPageInitLoaded
    ) {
      this._prevMasterPageInitLoaded =
        this.context?.isMasterPageInitLoaded ?? false;
      await this.ReportsSalesCustomerPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "reportssalescustomer",
      "footer_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["B2BCustomer"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "reportssalescustomer",
      "footer_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.ReportsSalesCustomerPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.ReportsSalesCustomerPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  ReportsSalesCustomerPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      customerCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.B2BGetRolesById !== undefined
            ? stateVars.B2BGetRolesById?.length > 0
              ? stateVars.B2BGetRolesById[0].customerCode
              : null
            : this.state.B2BGetRolesById?.length > 0
            ? this.state.B2BGetRolesById[0].customerCode
            : null
        ),
        "string"
      ),
      dateFilter_1: ReactSystemFunctions.convertToTypeByName(3, "number"),
      startDate_1: ReactSystemFunctions.convertToTypeByName("", "string"),
      endDate_1: ReactSystemFunctions.convertToTypeByName("", "string"),
      pageNumber_1: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ReportsSalesCustomer/ReportsSalesCustomerPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BGetRolesById = result?.data.b2BGetRolesById;
    stateVars.KuikaB2B_OrderSalesCustomerHeaderMobile =
      result?.data.kuikaB2B_OrderSalesCustomerHeaderMobile;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ReportsSalesCustomerPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ReportsSalesCustomerPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp186380Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "reportssalescustomer_373528_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("10", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_624937 =
      stateVars.KuikaB2B_OrderSalesCustomerHeaderMobile ??
      this.state.KuikaB2B_OrderSalesCustomerHeaderMobile;

    formVars.reportssalescustomer_894803_total = ReactSystemFunctions.value(
      this,
      stateVars.KuikaB2B_OrderSalesCustomerHeaderMobile !== undefined
        ? stateVars.KuikaB2B_OrderSalesCustomerHeaderMobile?.length > 0
          ? stateVars.KuikaB2B_OrderSalesCustomerHeaderMobile[0].totalRows
          : null
        : this.state.KuikaB2B_OrderSalesCustomerHeaderMobile?.length > 0
        ? this.state.KuikaB2B_OrderSalesCustomerHeaderMobile[0].totalRows
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  ReportsSalesCustomerComponent_532644_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ReportsSalesCustomerComponent_373528_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "reportssalescustomer_894803_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ReportsSalesCustomerComponent_373528_onChange1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ReportsSalesCustomerComponent_373528_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.B2BGetRolesById !== undefined
            ? stateVars.B2BGetRolesById?.length > 0
              ? stateVars.B2BGetRolesById[0].customerCode
              : null
            : this.state.B2BGetRolesById?.length > 0
            ? this.state.B2BGetRolesById[0].customerCode
            : null
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "reportssalescustomer_373528_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      endDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "reportssalescustomer_373528_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("10", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "ReportsSalesCustomer/ReportsSalesCustomerComponent_373528_onChange1_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.KuikaB2B_OrderSalesCustomerHeaderMobile =
        result?.data.kuikaB2B_OrderSalesCustomerHeaderMobile;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsSalesCustomerComponent_373528_onChange2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsSalesCustomerComponent_373528_onChange2_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ReportsSalesCustomerComponent_373528_onChange2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp186380Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "reportssalescustomer_373528_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("10", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ReportsSalesCustomerComponent_373528_onChange3_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ReportsSalesCustomerComponent_373528_onChange3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "reportssalescustomer_373528_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("10", "string")
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsSalesCustomerComponent_373528_onChange4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsSalesCustomerComponent_373528_onChange4_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  ReportsSalesCustomerComponent_373528_onChange4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "reportssalescustomer_373528_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("10", "string")
      )
    ) {
      stateVars.dataSource_624937 =
        stateVars.KuikaB2B_OrderSalesCustomerHeaderMobile ??
        this.state.KuikaB2B_OrderSalesCustomerHeaderMobile;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsSalesCustomerComponent_373528_onChange5_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsSalesCustomerComponent_373528_onChange5_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  ReportsSalesCustomerComponent_373528_onChange5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "reportssalescustomer_373528_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("10", "string")
      )
    ) {
      formVars.reportssalescustomer_894803_total = ReactSystemFunctions.value(
        this,
        stateVars.KuikaB2B_OrderSalesCustomerHeaderMobile !== undefined
          ? stateVars.KuikaB2B_OrderSalesCustomerHeaderMobile?.length > 0
            ? stateVars.KuikaB2B_OrderSalesCustomerHeaderMobile[0].totalRows
            : null
          : this.state.KuikaB2B_OrderSalesCustomerHeaderMobile?.length > 0
          ? this.state.KuikaB2B_OrderSalesCustomerHeaderMobile[0].totalRows
          : null
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  ReportsSalesCustomerComponent_518571_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "reportssalescustomer_330953_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "reportssalescustomer_179452_value",
        "string"
      ),
      "",
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ReportsSalesCustomerComponent_595833_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "reportssalescustomer_894803_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ReportsSalesCustomerComponent_595833_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ReportsSalesCustomerComponent_595833_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.B2BGetRolesById !== undefined
            ? stateVars.B2BGetRolesById?.length > 0
              ? stateVars.B2BGetRolesById[0].customerCode
              : null
            : this.state.B2BGetRolesById?.length > 0
            ? this.state.B2BGetRolesById[0].customerCode
            : null
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "reportssalescustomer_373528_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "reportssalescustomer_330953_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      endDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "reportssalescustomer_179452_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ReportsSalesCustomer/ReportsSalesCustomerComponent_595833_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KuikaB2B_OrderSalesCustomerHeaderMobile =
      result?.data.kuikaB2B_OrderSalesCustomerHeaderMobile;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ReportsSalesCustomerComponent_595833_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ReportsSalesCustomerComponent_595833_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_624937 =
      stateVars.KuikaB2B_OrderSalesCustomerHeaderMobile ??
      this.state.KuikaB2B_OrderSalesCustomerHeaderMobile;
    formVars.reportssalescustomer_894803_total = ReactSystemFunctions.value(
      this,
      stateVars.KuikaB2B_OrderSalesCustomerHeaderMobile !== undefined
        ? stateVars.KuikaB2B_OrderSalesCustomerHeaderMobile?.length > 0
          ? stateVars.KuikaB2B_OrderSalesCustomerHeaderMobile[0].totalRows
          : null
        : this.state.KuikaB2B_OrderSalesCustomerHeaderMobile?.length > 0
        ? this.state.KuikaB2B_OrderSalesCustomerHeaderMobile[0].totalRows
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ReportsSalesCustomerComponent_399319_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "ReportsCustomerSalesDetail",
      "orderNumber",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "reportssalescustomer_624937_value",
          "orderNumberWS"
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "ReportsSalesCustomer",
      "ReportsCustomerSalesDetail",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ReportsSalesCustomerComponent_894803_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.B2BGetRolesById !== undefined
            ? stateVars.B2BGetRolesById?.length > 0
              ? stateVars.B2BGetRolesById[0].customerCode
              : null
            : this.state.B2BGetRolesById?.length > 0
            ? this.state.B2BGetRolesById[0].customerCode
            : null
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "reportssalescustomer_373528_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      startDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "reportssalescustomer_330953_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      endDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "reportssalescustomer_179452_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ReportsSalesCustomer/ReportsSalesCustomerComponent_894803_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KuikaB2B_OrderSalesCustomerHeaderMobile =
      result?.data.kuikaB2B_OrderSalesCustomerHeaderMobile;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ReportsSalesCustomerComponent_894803_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ReportsSalesCustomerComponent_894803_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_624937 =
      stateVars.KuikaB2B_OrderSalesCustomerHeaderMobile ??
      this.state.KuikaB2B_OrderSalesCustomerHeaderMobile;
    formVars.reportssalescustomer_894803_total = ReactSystemFunctions.value(
      this,
      stateVars.KuikaB2B_OrderSalesCustomerHeaderMobile !== undefined
        ? stateVars.KuikaB2B_OrderSalesCustomerHeaderMobile?.length > 0
          ? stateVars.KuikaB2B_OrderSalesCustomerHeaderMobile[0].totalRows
          : null
        : this.state.KuikaB2B_OrderSalesCustomerHeaderMobile?.length > 0
        ? this.state.KuikaB2B_OrderSalesCustomerHeaderMobile[0].totalRows
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ReportsSalesCustomerComponent_416078_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.ReportsSalesCustomerPageInit();
    }
  }
}
